import { selectCurrentFolderName } from 'ducks/folders/selectors/items'
import {
  selectCurrentQueryId,
  selectSearchTotalCountByQueryId,
} from 'ducks/searches/selectors'
import { selectRoomFromUrl } from './rooms'

export const selectChatTitleName = state => {
  const currentRoom = selectRoomFromUrl(state)
  if (currentRoom.title) return currentRoom.title

  const folderName = selectCurrentFolderName(state)
  if (folderName) return folderName

  return 'Loading...'
}

export const selectChatTitleCount = state => {
  const folderName = selectCurrentFolderName(state)
  const queryId = selectCurrentQueryId(state)
  const conversationCount = selectSearchTotalCountByQueryId(state, queryId)
  if (folderName && (conversationCount || conversationCount === 0))
    return conversationCount
  return null
}
